module.exports = __webpack_public_path__ + "img/SCBT.10b2103e.png";